import firebase from "firebase/app";

import React from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

import { db } from "astrid-firebase";
import importStatuses from "astrid-firestore/src/api/imports/constants/importStatuses";
import updateImport from "astrid-firestore/src/api/imports/updateImport";

import Flex from "../../../../components/Flex/Flex";
import AsyncButton from "../../../ui/components/AsyncButton/AsyncButton";
import InstantSearch from "../../../ui/components/InstantSearch/InstantSearch";
import InstantSearchBox from "../../../ui/components/InstantSearch/InstantSearchBox";
import InstantSearchClear from "../../../ui/components/InstantSearch/InstantSearchClear";
import InstantSearchHits from "../../../ui/components/InstantSearch/InstantSearchHits";
import InstantSearchHitsPerPage from "../../../ui/components/InstantSearch/InstantSearchHitsPerPage";
import InstantSearchNumberOfHits from "../../../ui/components/InstantSearch/InstantSearchNumberOfHits";
import InstantSearchPagination from "../../../ui/components/InstantSearch/InstantSearchPagination";
import InstantSearchRefinements from "../../../ui/components/InstantSearch/InstantSearchRefinements";
import InstantSearchRefresh from "../../../ui/components/InstantSearch/InstantSearchRefresh";
import Toast from "../../../ui/components/Toast/Toast";
import PageView from "../../../ui/views/PageView/PageView";

import Table from "../../../tables/components/Table";

import ImportSourcesAutoDelivery from "../../components/ImportSourcesAutoDelivery/ImportSourcesAutoDelivery";
import useImportDropdownMenuOptions from "../../hooks/useImportDropdownMenuOptions";
import useImportsRefinements from "../../hooks/useImportsRefinements";
import useImportsTableColumns from "../../hooks/useImportsTableColumns";

export default function ImportsView() {
	const { t } = useTranslation();
	const navigate = useNavigate();

	const columns = useImportsTableColumns();
	const refinements = useImportsRefinements();

	const getDropdownMenuOptions = useImportDropdownMenuOptions();

	return (
		<InstantSearch routing indexName="imports">
			<InstantSearchRefresh refreshInterval={5000} />

			<PageView
				header={t("imports", "Imports")}
				sidebar={
					<>
						<InstantSearchBox />

						<InstantSearchRefinements refinements={refinements} />

						<ImportSourcesAutoDelivery />
					</>
				}
			>
				<Flex gap={10}>
					<InstantSearchClear />

					<InstantSearchHitsPerPage />

					<InstantSearchNumberOfHits />
				</Flex>

				<InstantSearchHits>
					<Table
						columns={columns}
						enableCheckboxes
						onClick={({ objectID }) => navigate(objectID)}
						getDropdownMenuOptions={getDropdownMenuOptions}
					>
						{({ selectedRows, setSelectedRowIds }) => (
							<Toast open={selectedRows.length > 0}>
								<AsyncButton
									onClick={async () => {
										for (const { id } of selectedRows) {
											await updateImport(firebase, db.collection("imports").doc(id), {
												status: importStatuses.PENDING,
											});
										}

										setSelectedRowIds([]);
									}}
								>
									{t("retry", "Retry")}
								</AsyncButton>
							</Toast>
						)}
					</Table>
				</InstantSearchHits>

				<InstantSearchPagination />
			</PageView>
		</InstantSearch>
	);
}
